export default {
  drinks: "DRINKS",
  food: "FOOD",
  dessert: "DESSERT",
  first: "First",
  second: "Second",
  mainCourses: "MAIN COURSES",
  comments: "Comments:",
  invoice: "Invoice",
  cookies: "Cookies",
  privacy: "Privacy",
  termsAndConditions: "Terms and Conditions",
  noRecordMessage: "No results found. Please, check the search filters!",
  askFor: "Ask for",
  keep: "Keep",
  close: "Close",
  everything: "Everything",
  done: "Done",
  toShare: "TO SHARE",
  companyName: "Company name",
  postalCode: "Postal Code",
  town: "Town",
  address: "Address",
  nameIsRequired: "Name is required",
  addressIsRequired: "Address is required",
  NIFIsRequired: "NIF is required",
  postalCodeIsRequired: "Zip code is required",
  cityIsRequired: "City is required",
  emailIsRequired: "Email is required",
  theEmailMustBeValid: "The email must be valid",
  charging: "Charging..."
};
